import { render, staticRenderFns } from "./lawsuitCosForm.vue?vue&type=template&id=14f22621&scoped=true"
import script from "./lawsuitCosForm.vue?vue&type=script&lang=js"
export * from "./lawsuitCosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f22621",
  null
  
)

export default component.exports